module.exports = __webpack_public_path__ + "img/marketing.8e57e12d.svg";